module.exports = __webpack_public_path__ + "img/olaotan.f3978bf9.jpeg";